"use client"

import dynamic from "next/dynamic";
import featuresData from "./featuresData";

const SectionTitle = dynamic(() => import("../Common/SectionTitle"), { ssr: false });
const SingleFeature = dynamic(() => import("./SingleFeature"), { ssr: false });

const Features = () => {
  return (
    <section
      id="features"
      className="bg-gray-50 py-20 md:py-28 dark:bg-gray-900"
    >
      <div className="container">
        <SectionTitle
          title="Why Choose Devkin Technologies?"
          paragraph="We deliver innovative, scalable, and secure technology solutions to help businesses thrive in a digital-first world."
          center
        />

        <div className="grid grid-cols-1 gap-x-10 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
          {featuresData.map((feature) => (
            <SingleFeature key={feature.id} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
